import { Injectable, Inject } from '@angular/core';
import { Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  private renderer: Renderer2;

  constructor(
    private rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document
  ) {
    // Initialisation du Renderer2 via le RendererFactory2
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  /**
   * Charge dynamiquement le script Google Analytics (gtag.js)
   * @param trackingId - ID de suivi principal (Google Analytics)
   * @param additionalConfigs - Un tableau d'ID pour d'autres configurations comme Google Ads
   */
  loadAnalytics(trackingId: string, additionalConfigs: string[] = []): void {
    if (!this.isScriptLoaded('google-analytics-script')) {
      // Charger le script gtag.js
      const gtagScript = this.renderer.createElement('script');
      gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
      gtagScript.async = true;
      gtagScript.id = 'google-analytics-script';
      this.renderer.appendChild(this.document.head, gtagScript);

      // Configurer Google Analytics une fois que le script est chargé
      const inlineScript = this.renderer.createElement('script');
      inlineScript.text = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${trackingId}');
        ${additionalConfigs.map(id => `gtag('config', '${id}');`).join('\n')}
      `;
      this.renderer.appendChild(this.document.head, inlineScript);
    } else {
      console.warn('Google Analytics script is already loaded.');
    }
  }

  /**
   * Supprimer le script Google Analytics
   */
  removeAnalytics(): void {
    const script = this.document.getElementById('google-analytics-script');
    if (script) {
      this.renderer.removeChild(this.document.head, script);
    } else {
      console.warn('Google Analytics script is not found.');
    }
  }

  /**
   * Vérifie si le script Google Analytics est déjà chargé
   * @param id - L'identifiant unique du script
   * @returns boolean - true si le script est chargé
   */
  private isScriptLoaded(id: string): boolean {
    return !!this.document.getElementById(id);
  }
}
